import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import Recorder from "./recorder";
import QuestionBox from "../QuestionPage/questionbox"
import ResultBox from "./ResultBox";
import ScoreCard from "./ScoreCard";
import SpacingBox from "./Spacing";

export default function SamplePage() {
  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative left-72 ml-3 top-28  bg-gray-100 h-auto  w-[1150px] rounded-sm">
        <h2 className=" pl-5 pt-4 text-3xl font-bold ">Title</h2>

        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
          Time Spent: 12.22
        </h2>
        <button class="bg-blue-500 hover:bg-green-700 text-white font-semibold py-1 px-1 rounded-sm ml-6 mr-3 mt-3">
          Medium
        </button>

        <button class="bg-green-500 hover:bg-green-700 text-white font-semibold py-1 px-1 rounded-sm">
          Attempted
        </button>

        <p className="p-4">
          Look at the text below. In the 35 seconds, you must read this text
          aloud as naturally and clearly as possible. You have 35 seconds to
          read aloud.
        </p>
        <Recorder/>
        <QuestionBox/>
        <ResultBox/>
        <ScoreCard/>
        <SpacingBox/>
      </div>
    </div>
  );
}
